<ng-container *ngIf="type=='problem'">
  <mat-icon [color]="status === 'resolved' ? 'primary' : 'warn'"
            [matTooltip]="status === 'resolved' ? 'resolved problem' : 'unresolved problem'">
    {{status === 'resolved' ? 'check_circle' : 'bug_report'}}
  </mat-icon>
</ng-container>
<ng-content></ng-content>
